import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../lib/translations';

const LanguageContext = createContext();

export const languages = [
  { code: 'de', name: 'Deutsch', flag: '🇨🇭' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('de');

  useEffect(() => {
    // Check URL for language parameter
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    
    // Check localStorage
    const savedLang = localStorage.getItem('easyweb-language');
    
    // Priority: URL > localStorage > default (de)
    // Note: We default to German for Swiss market SEO
    if (langParam && translations[langParam]) {
      setLanguage(langParam);
    } else if (savedLang && translations[savedLang]) {
      setLanguage(savedLang);
    }
    // Default stays 'de' for Swiss market
  }, []);

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem('easyweb-language', lang);
      
      // Update URL without reload
      const url = new URL(window.location);
      url.searchParams.set('lang', lang);
      window.history.replaceState({}, '', url);
    }
  };

  const t = (path) => {
    const keys = path.split('.');
    let result = translations[language] || translations.de;
    
    for (const key of keys) {
      if (result && typeof result === 'object' && key in result) {
        result = result[key];
      } else {
        // Fallback to German
        result = translations.de;
        for (const k of keys) {
          if (result && typeof result === 'object' && k in result) {
            result = result[k];
          } else {
            return path; // Return path if not found
          }
        }
        break;
      }
    }
    
    return result;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
